import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  exchangeCountFromModel,
  validateExchangeCountCondition,
  type ExchangeCountState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const EXCHANGE_COUNT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ExchangeCountState>>,
): ConditionType<ExchangeCountState, Condition.ExchangeCount> => ({
  name: "Number of previous exchanges",
  description(state) {
    if (state === undefined) {
      return "Number of previous exchanges less than";
    }
    return `Number of previous exchanges less than ${state}`;
  },
  Details(props: ConditionTypeDetailsProps<ExchangeCountState>) {
    return React.createElement(Details, props);
  },
  empty: (1).toFixed(0),
  fromModel(model) {
    return exchangeCountFromModel(model);
  },
  toModel(state) {
    return { type: Condition.EXCHANGE_COUNT, numExchanges: +state };
  },
  valid(state) {
    return validateExchangeCountCondition(state).valid;
  },
});

export { type ExchangeCountState } from "@redotech/redo-model/return-flow/condition-validate";
